export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
  color: string;
}

export const categories: Category[] = [
  {
    id: 'japanese',
    name: '日本h漫',
    slug: 'japanese-h-manga',
    description: '汇集日本本土原创h漫作品，涵盖知名画师与经典系列，呈现日式h漫独特的风格魅力与创作精髓。',
    icon: 'ri-global-fill',
    articleCount: 86,
    color: 'primary',
  },
  {
    id: 'chinese-translated',
    name: '汉化h漫',
    slug: 'chinese-translated',
    description: '精选经过汉化翻译的海外优质h漫资源，打破语言壁垒，让中文读者畅享全球h漫佳作。',
    icon: 'ri-translate',
    articleCount: 72,
    color: 'accent',
  },
  {
    id: 'doujin',
    name: '同人h漫',
    slug: 'doujin-h-manga',
    description: '探索丰富多彩的同人创作世界，汇集各类热门IP的二次创作h漫，展现同人画师的无限想象力。',
    icon: 'ri-group-fill',
    articleCount: 64,
    color: 'secondary',
  },
  {
    id: '3d',
    name: '3D h漫',
    slug: '3d-h-manga',
    description: '体验3D渲染技术带来的沉浸式h漫视觉盛宴，精致的立体画面与逼真的角色造型。',
    icon: 'ri-box-3-fill',
    articleCount: 48,
    color: 'primary',
  },
  {
    id: 'story',
    name: '剧情h漫',
    slug: 'story-h-manga',
    description: '注重剧情与人物塑造的h漫佳作，在精彩故事中展现角色间的情感纠葛与成长历程。',
    icon: 'ri-book-open-fill',
    articleCount: 55,
    color: 'accent',
  },
  {
    id: 'short',
    name: '短篇h漫',
    slug: 'short-h-manga',
    description: '短小精悍的h漫短篇合集，适合碎片时间阅读，快速领略h漫的多样风格与创意表达。',
    icon: 'ri-file-list-3-fill',
    articleCount: 93,
    color: 'secondary',
  },
  {
    id: 'full-color',
    name: '全彩h漫',
    slug: 'full-color-h-manga',
    description: '全彩上色的h漫作品精选，色彩丰富的画面带来更强的视觉冲击力与沉浸感。',
    icon: 'ri-palette-fill',
    articleCount: 41,
    color: 'primary',
  },
  {
    id: 'serialized',
    name: '连载h漫',
    slug: 'serialized-h-manga',
    description: '持续更新的连载h漫系列，追更党必备，第一时间获取最新章节的推荐与导航。',
    icon: 'ri-loop-left-fill',
    articleCount: 37,
    color: 'accent',
  },
];